export class RecordValoration {
    static EXCELENT = 3;
    static GOOD = 2;
    static NOT_BAD = 1;
    static BAD = 0;
    static UNDEFINED = -1;
}
